export async function handleClipboardFiles(event: ClipboardEvent, fileHandler: (syntheticEvent: Event) => void) {
    const items = event?.clipboardData?.items;
    if (!items) return;

    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file") {
            const file = item.getAsFile();
            if (!file) continue;

            const reader = new FileReader();
            reader.onload = () => {
                const newFile = new File([file], file.name, { type: file.type });
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(newFile);

                const syntheticEvent = new Event("change");
                Object.defineProperty(syntheticEvent, "target", {
                    writable: false,
                    value: { files: dataTransfer.files }
                });

                fileHandler(syntheticEvent as unknown as Event);
            };
            reader.readAsDataURL(file);
        }
    }
}
